<template>
  <div class="eddy-shielding-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>δ = 1/√(πfμσ) | 趋肤深度与涡流屏蔽$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Source (Solenoid) -->
          <g transform="translate(50, 120)">
             <rect x="-20" y="-40" width="40" height="80" fill="none" stroke="#888" stroke-width="2" />
             <path v-for="i in 5" :key="i" :d="`M -20,${-30 + i*12} L 20,${-30 + i*12}`" stroke="#cd7f32" stroke-width="2" />
             
             <!-- Magnetic Field Lines -->
             <g v-if="power">
                <path v-for="i in 3" :key="'f'+i" :d="getFieldPath(i)" 
                      fill="none" :stroke="fieldColor" stroke-width="1" :stroke-dasharray="i == 2 ? '' : '4,2'">
                   <animate attributeName="opacity" values="0.2;0.8;0.2" dur="0.1s" repeatCount="indefinite" />
                </path>
             </g>
          </g>

          <!-- The Shield (Metal plate or mesh) -->
          <g v-if="shieldActive" transform="translate(180, 40)">
             <rect width="20" height="160" fill="rgba(170, 170, 170, 0.8)" stroke="#fff" rx="2" />
             <!-- Eddy Current visualization -->
             <g v-if="power">
                <circle v-for="n in 5" :key="n" cx="10" :cy="20 + n*25" r="8" fill="none" stroke="#2ed573" stroke-width="1">
                   <animate attributeName="r" values="2;10" dur="0.5s" repeatCount="indefinite" />
                   <animate attributeName="opacity" values="1;0" dur="0.5s" repeatCount="indefinite" />
                </circle>
             </g>
          </g>

          <!-- The Sensor / Phone (The protected device) -->
          <g transform="translate(300, 120)">
             <rect x="-15" y="-30" width="30" height="60" fill="#222" stroke="#444" rx="4" />
             <rect x="-12" y="-20" width="24" height="40" :fill="signalColor" />
             <text x="-10" y="35" fill="#888" font-size="8">接收设备</text>
             <!-- Signal bars -->
             <g v-for="i in 4" :key="'b'+i">
                <rect :x="-10 + i*4" :y="15 - i*2" width="2" :height="i*2" :fill="i <= signalBars ? '#2ed573' : '#444'" />
             </g>
          </g>

          <text x="40" y="70" fill="#888" font-size="8">信号源 (HF)</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>信号强度: {{ (signalPercent).toFixed(0) }}%</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>电源开关</label>
             <el-switch v-model="power" active-color="#ffd700"></el-switch>
          </div>
          <div class="row items-center mt-2">
             <label>插入屏蔽板</label>
             <el-switch v-model="shieldActive" active-color="#1e90ff"></el-switch>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>电磁屏蔽利用了法拉第电磁感应定律。当高频交变磁场试图穿过良导体（如铜、铝）时，会在导体表面感应出强烈的**涡流**。根据楞次定律，这些涡流产生的感生磁场会抵消入射磁场，将其阻挡在导体之外。屏蔽效果取决于材料的电导率、厚度以及频率。这就是手机在电梯里信号变差、或微波炉门上的金属网能防止微波泄漏的原因。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EddyShieldingViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      power: true,
      shieldActive: false
    }
  },
  computed: {
    fieldColor() { return "#ffd700"; },
    signalPercent() {
       if (!this.power) return 0;
       return this.shieldActive ? 5 : 100;
    },
    signalBars() {
       if (!this.power) return 0;
       return this.shieldActive ? 1 : 4;
    },
    signalColor() {
       return this.signalPercent > 10 ? 'rgba(46, 213, 115, 0.2)' : 'rgba(255, 71, 87, 0.2)';
    }
  },
  methods: {
    getFieldPath(i) {
       let y = (i - 2) * 40;
       let reach = this.shieldActive ? 180 : 350;
       return `M 70,120 Q ${70 + reach/2},${120 + y} ${reach},120`;
    }
  }
}
</script>

<style scoped lang="scss">
.eddy-shielding-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.02); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(30, 144, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
